/* eslint-disable */
import { call, put } from 'redux-saga/effects'
import { path } from 'ramda'
import HappeningsTypes from '../Redux/HappeningsRedux'


export const kargoeHappening = function* kargoeHappening(api, action) {
  try {
    

    const response = yield call(api.kargorHappening)

    if (response.ok) {
        
      // const { response } = action // catch: undefined is not an object (evaluating '_response.data')
      const { data } = response
      const apiResponse = data
      console.tron.display({
        name: 'happing  me   data',
        preview: "expand",
        value: {
          message: data,
         
        }
      })
      // TODO: Should check the data that is returned, following can fail, eg: same user on two phones change at same time
      yield put(HappeningsTypes.kargoeSuccess(response))
    } else {
      console.tron.display({
        name: 'happing  me  error',
        preview: "expand",
        value: {
          message: response,
        
        }
      })
      yield put(HappeningsTypes.kargoeFailure(response))
    }
  }
  catch (e) {
  
    console.tron.display({
      name: 'happening me  error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  } 
}
